import React from 'react';
import PropTypes from 'prop-types';
import useGetImages from '../../hooks/use-get-images';
import VideoRender from './VideoRender';
import VideoModal from './VideoModal';
import Wrapper from '../Wrapper';
import getClassModifiers from '../../utils/get-class-modifiers';
import { shouldShowProperty } from '../../helpers';

const Video = ({
  url,
  modifier,
  autoplay,
  isCaptionDisplayed,
  caption,
  credits,
  areVideoCreditsDisplayed,
  provider,
  playInModal,
  imageId,
  ...props
}) => {
  const {
    data: { getFile: imageData },
    loading
  } = useGetImages(imageId);

  if (loading) return '';
  if (!url) return null;

  const modifiers = `video--${provider.toLowerCase()} ${getClassModifiers('video', {
    modifier,
    ...props
  })}`;

  const shouldDisplayCaption = shouldShowProperty({
    isDisplayed: isCaptionDisplayed,
    value: caption
  });
  const shouldDisplayCredits = shouldShowProperty({
    isDisplayed: areVideoCreditsDisplayed,
    value: credits
  });

  return (
    <Wrapper className="video" modifiers={modifiers}>
      {playInModal ? (
        <VideoModal
          url={url}
          modifier={modifier}
          autoplay={autoplay}
          provider={provider}
          imageData={imageData}
          {...props}
        />
      ) : (
        <VideoRender
          url={url}
          modifier={modifier}
          autoplay={autoplay}
          provider={provider}
          imageData={imageData}
          {...props}
        />
      )}

      {(shouldDisplayCaption || shouldDisplayCredits) && (
        <div className="video__details" data-testid="video-details">
          {shouldDisplayCaption && <div className="caption">{caption}</div>}
          {shouldDisplayCredits && <div className="credits">{credits}</div>}
        </div>
      )}
    </Wrapper>
  );
};

Video.propTypes = {
  url: PropTypes.string,
  modifier: PropTypes.string,
  caption: PropTypes.string,
  credits: PropTypes.string,
  autoplay: PropTypes.bool,
  areVideoCreditsDisplayed: PropTypes.bool,
  isCaptionDisplayed: PropTypes.bool,
  provider: PropTypes.string,
  playInModal: PropTypes.bool,
  imageId: PropTypes.string
};

Video.defaultProps = {
  caption: '',
  credits: '',
  modifier: '',
  imageId: '',
  url: '',
  provider: 'youtube',
  autoplay: false,
  isCaptionDisplayed: false,
  areVideoCreditsDisplayed: false,
  playInModal: false
};

export default Video;
